
document.addEventListener('DOMContentLoaded', function () {
  const checkboxes = document.querySelectorAll('input[name="related_companies[]"]');
  const sectionSelectors = document.querySelectorAll('.select-section');
  const threadBtn = document.querySelector('.thread-exchange-button');
  const printBtn = document.querySelector('.print-button');
  const tableRows = document.querySelectorAll('.thread-exchange__table tbody tr');

  function updateTableColumns() {
    const selectedValues = Array.from(document.querySelectorAll('input[name="related_companies[]"]:checked')).map(c => c.value);
    
    // Toggle header visibility
    document.querySelectorAll('.dynamic-header').forEach(header => {
      const company = header.getAttribute('data-related-company');
      header.style.display = selectedValues.includes(company) ? 'table-cell' : 'none';
    });

    tableRows.forEach(row => {
      const threadData = JSON.parse(row.getAttribute('data-thread'));

      // Remove all existing related company <td>s
      row.querySelectorAll('td.related__companies').forEach(td => td.remove());

      // Append new <td>s for selected companies
      selectedValues.forEach(company => {
        const match = threadData.find(t => t.related_company_name.toLowerCase() === company);
        const td = document.createElement('td');
        td.classList.add('related__companies','dynamic-element');
        td.setAttribute('data-related-company', company);
        td.innerText = match ? match.related_thread_id : '';
        row.appendChild(td);
      });
    });
  }

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const checkedCount = document.querySelectorAll('input[name="related_companies[]"]:checked').length;

      checkboxes.forEach(cb => {
        cb.disabled = checkedCount >= 3 && !cb.checked;
      });

      updateTableColumns();
    });
  });

  sectionSelectors.forEach(checkbox => {
    checkbox.addEventListener('change', (event) => {
      const status = event.target.checked;
      const targetElements = document.querySelectorAll(`.${event.target.value}`);
      targetElements.forEach(el => {
        el.style.display = status ? "block" : "none";
      });
    });
  });

  threadBtn.addEventListener('click', () => {
    const targetElement = document.querySelector('.thread-exchange');
    targetElement.scrollIntoView({ behavior: "smooth" });
  });

  printBtn.addEventListener('click', () => {
    const printContents = document.querySelector('.cc-thread-exchange').innerHTML;
    const printWindow = window.open('', '', 'height=600,width=800');
    printWindow.document.write('<html><head><title>Print</title></head><body>');
    printWindow.document.write(printContents);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.print();
      printWindow.close();
    };
  });

  // This was causing related company columns to hide on print
  // updateTableColumns();
});
